const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "levelEvaluationByToken/SET_LEVEL_EVALUATION":
      return {
        ...state,
        [action.levelEvaluationToken]: {
          ...state[action.levelEvaluationToken],
          result: action.payload,
        },
      }
    case "levelEvaluationByToken/SET_LOADING":
      return {
        ...state,
        [action.levelEvaluationToken]: {
          ...state[action.levelEvaluationToken],
          loading: action.payload,
        },
      }
    case "levelEvaluationByToken/SET_ERROR":
      return {
        ...state,
        [action.levelEvaluationToken]: {
          ...state[action.levelEvaluationToken],
          error: action.payload,
        },
      }
    case "LOGOUT":
      return initialState
    default:
      return state
  }
}
